import CheckIcon from '../assets/check-icon-circle.svg';
import { CONFIGURATION_STEPS, ConfigurationStepId, ConfigurationStepStatus } from './eoaConfigurationSteps';

interface EoaConfigurationTrackerProps {
  currentStepId: ConfigurationStepId;
  statuses: Record<ConfigurationStepId, ConfigurationStepStatus>;
  onStepSelect: (stepId: ConfigurationStepId) => void;
}

const EoaConfigurationTracker = ({ currentStepId, statuses, onStepSelect }: EoaConfigurationTrackerProps) => {
  return (
    <ol className="eoa-configuration-tracker" aria-label="EOAA configuration progress">
      {CONFIGURATION_STEPS.map((step) => {
        const status = statuses[step.id];
        const isCurrent = step.id === currentStepId;

        return (
          <li key={step.id} className={`eoa-configuration-tracker-item eoa-configuration-tracker-item--${status}`}>
            <button
              type="button"
              className="eoa-configuration-tracker-button"
              aria-current={isCurrent ? 'step' : undefined}
              onClick={() => onStepSelect(step.id)}
            >
              <span className="eoa-configuration-tracker-dot" aria-hidden="true">
                {status === 'completed' ? <img src={CheckIcon} alt="" width={32} height={32} /> : null}
              </span>
              <span className="eoa-configuration-tracker-label">{step.trackerLabel}</span>
            </button>
          </li>
        );
      })}
    </ol>
  );
};

export default EoaConfigurationTracker;
